import { notification } from 'antd';
import { useMutation, useQueryClient } from 'react-query';

import { Carrier } from '../../models/Carrier';
import { Option } from '../../models/Option';
import carrierService from '../../services/carrierService';

export const useOptionUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation<Option, Error, Option>(carrierService.updateOption, {
    onSuccess: (data) => {
      queryClient.setQueryData<Option | null>(
        ['carrierOption', data.carrierId],
        data
      );
      queryClient.setQueryData<Carrier | undefined>(
        ['carrier', data.carrierId],
        (carrier?: Carrier) =>
          carrier && {
            ...carrier,
            option: data,
          }
      );
      notification.success({
        description: 'Changes saved successfully.',
        message: 'Success',
      });
    },
  });
};
